import styled_components from "styled-components";
import { Flex } from "pcln-design-system";
const StyledLoadingBox = /*#__PURE__*/ styled_components(Flex).withConfig({
    displayName: "StyledLoadingBubble__StyledLoadingBox"
})([
    "border-radius:16px;padding-left:11px;padding-right:11px;@keyframes blink_1{0%{opacity:0.3;}10%{opacity:0.6;}33%{opacity:1;}66%{opacity:0.6;}99%{opacity:0.3;}}@keyframes blink_2{0%{opacity:0.3;}33%{opacity:0.6;}66%{opacity:1;}99%{opacity:0.6;}}@keyframes blink_3{0%{opacity:0.1;}33%{opacity:0.3;}66%{opacity:0.6;}99%{opacity:1;}}div#ellipses_1{animation:blink_1 1s infinite;}div#ellipses_2{animation:blink_2 1s infinite;}div#ellipses_3{animation:blink_3 1s infinite;}"
]);
export { StyledLoadingBox };
